export function slugifyCar(car) {
  // Example: "Peugeot 208 Automatic" => "peugeot_208_automatic"
  return `${car.make}_${car.model}_${car.transmission}`
    .toLowerCase()
    .replace(/\s+/g, "_")
    .replace(/[^a-z0-9_]/g, "");
}